<template>
  <div
    v-if="message?.text"
    :class="message.role"
    class="tw-p-6 tw-flex"
  >
    <!-- <div class="tw-mt-3 tw-mr-3">{{userIcon}}</div> bulma fucking sucs and the content class has a top and right margin for bullet points-->
    <div
      class="content"
      v-html="message.text"
    />
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useChatStore } from '@frontend/ui/stores/chatStore';


export default {
  name: 'ChatMessage',
  components: { },
  props: ['message'],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    userIcon() {
      return this.message.role === 'user' ? '👤' : '🤖';
    },
    ...mapStores(useChatStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>
.user {
  @apply tw-bg-slate-100;
}
/* .assistant {
  @apply tw-bg-slate-200;
} */
</style>
